module.exports = __webpack_public_path__ + "img/Hospital2.d53c8caf.jpg";